(function (angular) {

    window.app
        .directive('stickyApplication', () => {
            return {
                template: `<div class="stickyApp" ng-controller="stickyAppCtrl" ng-if="showStickyApp">
                            <div class="container">
                                <div class="calc-wrp" flex="40" flex-sm="60" flex-xs="70">
                                    <div class="calc-block">
                                        <div class="values">
                                            <input name="costVal" ng-model="costVal" value="costVal" id="costValSt"><span>zł</span>
                                        </div>
                                        <div class="params"><p class="sum"> Ile pieniedzy ?</p></div>
                                    </div>
                                    <div class="calc-block">
                                        <div class="values">
                                            <input name="durationVal" ng-model="durationVal" value="durationVal" id="durationValSt"><span>dni</span>
                                        </div>
                                        <div class="params"><p class="period">Na jak dlugo ?</p></div>
                                    </div>
                                </div>
                                <div layout layout-align="space-around center" flex="50" flex-sm="40" flex-xs="25">
                                    <p class="desc-text hide-sm hide-xs">Wypełnij jednen wniosek<br> i uzyskaj najlepszą ofertę</p>
                                    <div>
                                        <button href="/application" aria-label="Wyślij wniosek" ng-click="setCalcData()" class="action-btn main-sa-button">Wyślij wniosek</button>
                                    </div>
                                </div>
                            </div>
                            <span class="close-sticky-app" ng-click="closeStickyApp()" aria-label="close">X</span>
                        </div>`
            };
        })
})(window.angular);


// WEBPACK FOOTER //
// src/js/controllers/singleApplication/sticky-application.js